export const dashboardCustomizeConstants = {
  widget1: 'Alarm List',
  widget2: 'Available Groups',
  widget3: 'Current Measurement Values',
  widget4: 'Monitoring Point',
};

export const alarmListMode = [
  { id: 1, name: 'Global' },
  { id: 2, name: 'Adaptive' },
  { id: 3, name: 'Filter by group' },
];

export const dashboardCustomizeAlarmListData = [
  {
    groupId: 1,
    sensorId: 1,
    timeDetected: '03/01/22 08:28 AM',
    department: 'Department 1',
    group: 'Group 1',
    location: 'Location 1',
    name: 'Name 1',
    parameter: 'Temp',
    acknowledged: false,
    alarmStatus: 'Hi Alarm: 8.1>=8.0C',
    alarmState: 1,
    color: 'red',
  },
  {
    groupId: 2,
    sensorId: 2,
    timeDetected: '03/01/22 08:28 AM',
    department: 'Department 2',
    group: 'Group 2',
    location: 'Location 2',
    name: 'Name 2',
    parameter: 'Temp',
    acknowledged: false,
    alarmStatus: 'Hi Alarm: 8.1>=8.0C',
    alarmState: 1,
    color: 'cyan/blue',
  },
  {
    groupId: 3,
    sensorId: 3,
    timeDetected: '03/01/22 08:28 AM',
    department: 'Department 3',
    group: 'Group 3',
    location: 'Location 3',
    name: 'Name 3',
    parameter: 'Temp',
    acknowledged: false,
    alarmStatus: 'Hi Alarm: 8.1>=8.0C',
    alarmState: 1,
    color: 'yellow',
  },
  {
    groupId: 4,
    sensorId: 4,
    timeDetected: '03/01/22 08:28 AM',
    department: 'Department 4',
    group: 'Group 4',
    location: 'Location 4',
    name: 'Name 4',
    parameter: 'Temp',
    acknowledged: false,
    alarmStatus: 'Hi Alarm: 8.1>=8.0C',
    alarmState: 1,
    color: '',
  },
];

export const dashboardCustomizeAvailableGroupData = [
  {
    groupId: 2,
    groupName: 'Group 1',
    numWarnings: 0,
    numAlarms: 0,
    numErrors: 2,
    numSensors: 5,
    numOverriden: 3,
    state: false,
    maps: 'WarehouseDemo',
    mapDepartmentId: 1,
  },
  {
    groupId: 3,
    groupName: 'Group 2',
    numWarnings: 0,
    numAlarms: 2,
    numErrors: 2,
    numSensors: 5,
    numOverriden: 3,
    state: false,
    maps: 'WestCoast 2Aug2021',
    mapDepartmentId: 2,
  },
  {
    groupId: 5,
    groupName: 'Group 3',
    numWarnings: 0,
    numAlarms: 0,
    numErrors: 0,
    numSensors: 1,
    numOverriden: 1,
    state: false,
    maps: 'LabDemo',
    mapDepartmentId: 1,
  },
  {
    groupId: 6,
    groupName: 'Group 4',
    numWarnings: 0,
    numAlarms: 0,
    numErrors: 0,
    numSensors: 0,
    numOverriden: 0,
    state: false,
    maps: '',
    mapDepartmentId: 11,
  },
];

export const dashboardCustomizeCMVData = [
  {
    sensorId: 79,
    sensorTypeId: 66,
    location: 'Simulator 1',
    name: '1234567890000000',
    status: '#         ',
    parameter: 'temp',
    textValue: '4.4',
    units: 'C               ',
    alarmImage: 'Error.png',
    timeStamp: '01/14/23 09:13 PM',
    currentAlarmState: 7,
    currentStatus: 7,
  },
  {
    sensorId: 89,
    sensorTypeId: 66,
    location: 'Simulator 2',
    name: '123456789000000A',
    status: '#         ',
    parameter: 'temp',
    textValue: '7.2',
    units: 'C               ',
    alarmImage: 'Error.png',
    timeStamp: '01/14/23 09:12 PM',
    currentAlarmState: 7,
    currentStatus: 7,
  },
  {
    sensorId: 135,
    sensorTypeId: 1,
    location: 'Simulator 3',
    name: '123456789000000B',
    status: 'OK        ',
    parameter: '',
    textValue: '20',
    units: 'C               ',
    alarmImage: 'OK.png',
    timeStamp: '01/14/23 09:12 PM',
    currentAlarmState: 0,
    currentStatus: 0,
  },
  {
    sensorId: 69,
    sensorTypeId: 1,
    location: 'Simulator 4',
    name: '123456789000000C',
    status: 'OK        ',
    parameter: '',
    textValue: 'Jan 13 2023  3:54PM',
    units: 'C               ',
    alarmImage: 'OKOverride.png',
    timeStamp: '01/13/23 10:54 AM',
    currentAlarmState: 0,
    currentStatus: 0,
  },
];

export const MPColumns = [
  {
    dataField: 'name',
    text: 'Name',
  },
  {
    dataField: 'groupName',
    text: 'Group',
  },
  {
    dataField: 'location',
    text: 'Location',
  },
  {
    dataField: 'alarmType',
    text: 'Alarm Type',
    formatter: (cell) => (cell ? 'Yes' : 'No'),
    filterValue: (cell) => (cell ? 'Yes' : 'No'),
  },
  {
    dataField: 'timeDetected',
    text: 'Time Detected',
    isDateTime: true,
  },
  {
    dataField: 'units',
    text: 'Units',
  },
  {
    dataField: 'textValue',
    text: 'textValue',
  },
  {
    dataField: 'alarmPriority',
    text: 'Alarm Priority',
  },
];

export const dashboardCustomizeMonitoringPointData = [
  {
    ackEnabled: false,
    sensorId: 4,
    alarmPriority: 4,
    disabled: false,
    name: 'Name 1',
    location: 'Location 1',
    groupId: 48,
    groupName: 'Group Name',
    textValue: 'Value',
    parameter: 'Parameter',
    units: 'Units',
    device: 'Device',
    alarmType: 'Alarm Type',
    timeInfo: 'MM/DD/YY HH:MM AM/PM',
    timeDetected: 'MM/DD/YY HH:MM AM/PM',
  },
  // {
  //   ackEnabled: false,
  //   sensorId: 1,
  //   alarmPriority: 1,
  //   disabled: false,
  //   name: 'Name 2',
  //   location: 'Location 2',
  //   groupId: 48,
  //   groupName: 'Group Name',
  //   textValue: 'Value',
  //   parameter: 'Parameter',
  //   units: 'Units',
  //   device: 'Device',
  //   alarmType: 'Alarm Type',
  //   timeInfo: 'MM/DD/YY HH:MM AM/PM',
  //   timeDetected: 'MM/DD/YY HH:MM AM/PM',
  // },
  // {
  //   ackEnabled: false,
  //   sensorId: 2,
  //   alarmPriority: 2,
  //   disabled: false,
  //   name: 'Name 3',
  //   location: 'Location 3',
  //   groupId: 48,
  //   groupName: 'Group Name',
  //   textValue: 'Value',
  //   parameter: 'Parameter',
  //   units: 'Units',
  //   device: 'Device',
  //   alarmType: 'Alarm Type',
  //   timeInfo: 'MM/DD/YY HH:MM AM/PM',
  //   timeDetected: 'MM/DD/YY HH:MM AM/PM',
  // },
  // {
  //   ackEnabled: false,
  //   sensorId: 3,
  //   alarmPriority: 3,
  //   disabled: false,
  //   name: 'Name 4',
  //   location: 'Location 4',
  //   groupId: 48,
  //   groupName: 'Group Name',
  //   textValue: 'Value',
  //   parameter: 'Parameter',
  //   units: 'Units',
  //   device: 'Device',
  //   alarmType: 'Alarm Type',
  //   timeInfo: 'MM/DD/YY HH:MM AM/PM',
  //   timeDetected: 'MM/DD/YY HH:MM AM/PM',
  // },
];
